import type { RouteConfig } from "@/types/routestypes";
import { lazy } from "react";

const LeaveSettingsPage = lazy(() => import("@/pages/LeaveSettings/LeaveSettingsPage"));
const LeaveSettings = lazy(() => import("@/pages/LeaveSettings/LeaveSettings"));
const SetLeaveApprover = lazy(() => import("@/pages/LeaveSettings/SetLeaveApprover"));

const LeaveSettingRoute: RouteConfig = {
    path: "",
    pageName: "Leave Setting",
    element: <LeaveSettingsPage />,
    permission: ["LeaveSetting"],
    children: {
        LEAVE_SETTINGS: {
            path: "leavesettingcmp",
            element: <LeaveSettings />,
            pageName: "Leaves Setting",
            sidebar: { show: true },
        },
        SET_LEAVE_APPROVER: {
            path: "setapprovers",
            element: <SetLeaveApprover />,
            pageName: "Set Leave Approver",
            sidebar: { show: true },
        }
    }
}
export default LeaveSettingRoute;
